module.exports = __webpack_public_path__ + "8318e215e1a0440113471997b170ddff.png";